export enum PaperWidth {
  WIDTH_58 = "WIDTH_58",
  WIDTH_80 = "WIDTH_80",
}
